export function multistreamMiddleware(player) {
    // Middleware like this gets invoked in the same call stack as the user event that triggered it.
    // iOS Safari doesn't normally allow programmatic calls to play() unless triggered through a
    // user interaction event listener at least once (and/or if the video is muted).
    return {
        play: function (terminated, value) {
            if (player.usingPlugin('multistream')) {
                player.multistream()?.handlePlayerPlaying();
            }

            return value;
        }
    }
}
